import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
	allFilterPages,
	blockLibraryCollectionFields,
	blockLibraryDesignFields
} from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v2/FilterComponent';
import CardViewItems from '@features/assets/components/blockLibrary/CardViewItems';
import CollectionViewItems from '@features/assets/components/blockLibrary/CollectionViewItems';

import { setShowItemsCount } from '@store/filter/action';

const BlockLibrary = ({ isShowFilter, selectedViewType, setTotalElements }) => {
	const dispatch = useDispatch();

	const filterConfig =
		selectedViewType === 'CARD_VIEW'
			? {
					filterPageName: allFilterPages.BLOCK_LIBRARY_CARD_VIEW_LIST,
					fields: blockLibraryDesignFields
				}
			: {
					filterPageName: allFilterPages.BLOCK_LIBRARY_COLLECTION_VIEW_LIST,
					fields: blockLibraryCollectionFields
				};

	const { filterPageName, fields } = filterConfig;

	useEffect(() => {
		dispatch(setShowItemsCount(filterPageName === allFilterPages.BLOCK_LIBRARY_CARD_VIEW_LIST));
	}, [filterPageName, dispatch]);

	return (
		<>
			<section className="filter-data-container filter-v3-data-container under-inner-tabs bg-white">
				<FilterComponent
					filterPageName={filterPageName}
					fields={fields}
					showFilter={isShowFilter}
					isDependentFilter={true}
				/>
				<div className="data-table">
					{selectedViewType === 'CARD_VIEW' ? (
						<CardViewItems setTotalElements={setTotalElements} />
					) : (
						<CollectionViewItems setTotalElements={setTotalElements} />
					)}
				</div>
			</section>
		</>
	);
};

export default BlockLibrary;
